import { isValidZipCode } from '@brands/Utils/validation';
import * as Yup from 'yup';

import { isValidPhoneNumber } from '../../../Utils/validation';

export const validationSchema = Yup.object().shape({
  pharmacy_name: Yup.string().trim().required('Pharmacy name is required'),
  pharmacy_street_address: Yup.string().trim().required('Pharmacy street address is required'),
  pharmacy_city: Yup.string().trim().required('Pharmacy city is required'),
  pharmacy_state: Yup.string().trim().required('Pharmacy state is required'),
  pharmacy_zip_code: Yup.string()
    .trim()
    .required('Pharmacy zipcode is required')
    .test('is-valid-zip', 'Invalid pharmacy zip code', (value) => (value ? isValidZipCode(value) : true)),
  pharmacy_phone_number: Yup.string()
    .required('Pharmacy phone number is required')
    .test('test-phone-number', 'Enter Valid Phone Number', (value) => {
      if (value && !isValidPhoneNumber(value)) {
        return false;
      }
      return true;
    }),
});
